module.exports = __webpack_public_path__ + "img/pexels-fauxels-3182759.bf817151.png";